<p class="modal-title">Your estimated tax savings</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>This number represents the estimated amount you'll save in taxes by contributing and withdrawing from your HSA,
    accounting for tax-free withdrawals and the reduction in FICA taxes through tax-free payroll deposits.</p>